import $ from "jquery";
import __ajax from "../../utils/submit-form/__ajax";

const deleteWishlist = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-delete-wishlist",
    };

    $(document).on("click", el.button, function (e) {
      e.preventDefault();

      const thisEl = $(this);
      $("body").addClass("mi-loading");

      __ajax(thisEl, {
        wishlist_id: thisEl.data("wishlist_id"),
      })
        .then((res) => {
          if (res.success) {
            thisEl.parent().parent().remove();
          }
          $("body").removeClass("mi-loading");
        })
        .catch((err) => {
          $("body").removeClass("mi-loading");
          console.error(err);
        });
    });
  };

  init();
};

try {
  deleteWishlist();
} catch (error) {
  console.error("deleteWishlist", error);
}
